// Centralized branding & legal copy. Change in one place to rebrand.
export const BRANDING = {
  name: "Ontario Doctor Discovery",
  org: "Techdroid Inc.",
  tagline: "An Ontario healthcare discovery and community availability signal platform.",
  positioning:
    "Ontario Doctor Discovery helps Ontario residents discover doctors and availability signals based on public information and community reports. Availability may change. Please confirm directly with clinics.",
  disclaimer:
    "Doctor availability may change. Information shown is based on public sources and community reports. Please confirm directly with the clinic.",
  consentText: "I will not include personal health information.",
  demoLabel: "",
  notWhatItIs: [
    "Not medical advice",
    "Not an official government healthcare source",
    "Not a doctor booking platform",
    "Not a patient records system",
  ],
};
